import * as React from 'react';
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Avatar from '@mui/material/Avatar';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import PersonIcon from '@mui/icons-material/Person';
import AddIcon from '@mui/icons-material/Add';
import StraightenOutlinedIcon from '@mui/icons-material/StraightenOutlined';
import Typography from '@mui/material/Typography';
import { blue } from '@mui/material/colors';
import { connect } from 'react-redux'
import {PaperComponent} from '../../../utils/Common'

const emails = ['username@gmail.com', 'user02@gmail.com'];

function FontSizeModal(props) {
  const { onClose, open } = props;
  var mainLayers = props.main.mainLayers;
  const [size, setSize] = useState(12);

  useEffect(() => {
    var target = props.main.menuControl.target;
    if(target && target.get('fontSize')){
      setSize(target.get('fontSize'))
    }
  }, [open])
  
  const onChange = (e)=>{
    setSize(e.target.value)
  }
  const onOk = (e)=>{
    if(size)
      props.onOk(size)
  }
  return (
    <Dialog 
      PaperComponent={PaperComponent}
      PaperProps={{drag_id:'fontsize-dialog-title'}}
      aria-labelledby="fontsize-dialog-title"
      open={open}>
      <DialogTitle id='fontsize-dialog-title' style={{display:'flex', alignItems:'center'}}><StraightenOutlinedIcon style={{marginRight: 10}}/> Font Size</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {/* To subscribe to this website, please enter your email address here. We
          will send updates occasionally. */}
        </DialogContentText>
        <TextField
          name="size"
          margin="dense"
          label="Size"
          type="name"
          fullWidth
          variant="standard"
          value={size}
          onChange={onChange}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onOk}>Ok</Button>
        <Button onClick={onClose}>Cancel</Button>
      </DialogActions>
    </Dialog>
  );
}
const mapStateToProps = (state) => {
    return {
      main: state.main,
    };
  };
  
  const mapDispatchProps = (dispatch) => {
    return {   
    };
  };
  
export default connect(mapStateToProps, mapDispatchProps)(FontSizeModal);